import { api_base } from "./Caller";
import { BalanceManager } from "./utils/balanceManager";
import { fullscreenListener } from "./utils/listener";


export class MongibelloForgeUtilities {
    private _isPlaying: boolean = false;
    private _isPlayingFreeSpin: boolean = false;
    private _isPlayingPickbonus: boolean = false;
    private _isPlayingLinkSpin: boolean = false;
    private _isGameOn: boolean = false;
    
    constructor(private caller: api_base) {
        fullscreenListener();
    }

    private getBetCents(): number {
        return this.caller.getLevel() * this.caller.getCoin(); 
    }
    
    //Controllo del balance se è sufficiente per giocare
    public hasEnoughBalance(): boolean {
        if((window as any).GENERAL_CONFIG.checkCredits === false) return true
        const bet = this.getBetCents();
        const balance = BalanceManager.get();     

        const ok = bet <= balance;

        if (!ok) {
            (window as any).UIBridge?.showPopupControl("popup.insufficientBalance", false, false, false, false, 3000);
        }
    
        return ok;
    }

    public setMenuVisibility(value: boolean, disable?: boolean) {
        if (value === true) {
            (window as any).UIBridge?.showAll();
        } else {
            (window as any).UIBridge?.hideAll();
        }
        if (disable === true) {
            this.hideAllInGame();
        }
    }

    public get isPlayingFreeSpin(): boolean {
        return this._isPlayingFreeSpin;
    }

    public set isPlayingFreeSpin(value: boolean) {
        this._isPlayingFreeSpin = value;
        if (value === true) {
            (window as any).UIBridge?.hideAll();
        } else {
            (window as any).UIBridge?.showAll();
        }
    }

    public getIsPlayingLinkSpin(): boolean {
        return this._isPlayingLinkSpin;
    }

    public setIsPlayingLinkSpin(value: boolean) {
        this._isPlayingLinkSpin = value;
        if (value === true) {
            (window as any).UIBridge?.hideAll();
        } else {
            (window as any).UIBridge?.showAll();
        }
    }
    
    public getIsPlayingPickbonus(): boolean {
        return this._isPlayingPickbonus;
    }

    public setIsPlayingPickbonus(value: boolean) {
        this._isPlayingPickbonus = value;
        if (value === true) {
            (window as any).UIBridge?.hideAll();
        } else {
            (window as any).UIBridge?.showAll();
        }
    }

    public getIsPlaying(): boolean {
        return this._isPlaying;
    }

    public setIsPlaying(value: boolean) {
        this._isPlaying = value;

        if (value === true) {
            this.hideAllInGame();
        }
        if ( value === false) {
            this.turnOnAllInGame();
        }   
    }

    public get isGameOn(): boolean {
        return this._isGameOn;
    }

    public set isGameOn(value: boolean) {
        this._isGameOn = value;
        this.turnOnAllInGame();
    }

    public winUpdate(win : number){
        BalanceManager.add(win);

        (window as any).UIBridge?.setBalance((window as any).FORMATTER.formatCurrency(BalanceManager.get(), true));
    }

    public winButtonUpdate(win: number){
        (window as any).UIBridge?.setWin((window as any).FORMATTER.formatCurrency(win, true));
        (window as any).UIBridge?.showWinControl();
    }
    
    private turnOnAllInGame(){
        (window as any).UIBridge?.showAll();
    }

    private hideAllInGame(){
        (window as any).UIBridge?.disableMenuButton();
        (window as any).UIBridge?.disableCoinControl();
        (window as any).UIBridge?.disableBetControl();
        (window as any).UIBridge?.disableIncrementControl();
    }

    public setAndShowBoxText(text: string){
        (window as any).UIBridge?.setTextBoxText(text);
        (window as any).UIBridge?.showTextBox();
    }
    public hideBoxText(){
        (window as any).UIBridge?.setTextBoxText("");
        (window as any).UIBridge?.hideTextBox();
    }
    public showAllMenuWithoutEnable(): void {
        (window as any).UIBridge?.hidePopupControl();
        (window as any).UIBridge?.showAllAfterSlowConnection?.();
    }
    public setIncrementText(incrementNumber: string): void {
        (window as any).UIBridge?.setIncrementText(incrementNumber);
    }
}